module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-1-yellow.svg";